export type Locale = 'ja' | 'en' | 'zh';

export const LOCALES: Locale[] = ['ja', 'en', 'zh'];

export const DEFAULT_LOCALE: Locale = 'ja';

export const LOCALE_LABEL: Record<Locale, string> = {
  ja: '日本語',
  en: 'English',
  zh: '简体中文',
};

export function isLocale(value: unknown): value is Locale {
  return value === 'ja' || value === 'en' || value === 'zh';
}
